"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
function _default(oldKey, key) {
  return query => {
    const value = query[oldKey];
    return value ? {
      [key]: String(value)
    } : {};
  };
}